module.exports = __webpack_public_path__ + "static/media/TableScratch_After.a6647dcf.jpg";